import FormatService from '../format';

function formatValue(value) {
  // given values are in cents : convert to euros to use numeral

  return FormatService.formatCentsToCurrency(value, true);
}

export default formatValue;
